import React, { useEffect } from 'react';
import UserListWidget from '../../MultiRole/UserAccessListWidget/UserListWidget';
import { useLanguage } from '../../../../API/Context/LanguageContext';
import { useUserWhitelist } from '../../../../API/Hooks/useUserWhitelist';
import WhitelistService from '../../../../API/Services/WhitelistService';
import VocabWhitelistForm from '../../../../ConfigFiles/multilingual/VocabWhitelistForm';
import type { AuthorizedTranslatedUser } from '../../../../Types/schema-helpers';

interface WhitelistWidgetProps {
  initialUsername?: string | null | undefined;
  onSaveSuccess?: () => void;
}

const WhitelistWidget: React.FC<WhitelistWidgetProps> = ({
  initialUsername,
  onSaveSuccess,
}) => {
  const { lan } = useLanguage();
  const { whiteList, updateWhitelist, readWhitelist } = useUserWhitelist();

  // Initial fetch of the whitelist data
  useEffect(() => {
    readWhitelist();
  }, [readWhitelist]);

  const handleSave = async (updatedUsers: (AuthorizedTranslatedUser | string)[]) => {
    const success = await updateWhitelist(updatedUsers);
    if (!success) {
      throw new Error('Failed to update whitelist.');
    }
  };

  return (
    <UserListWidget
      title={VocabWhitelistForm.whitelist_tittle[lan] || 'Whitelist'}
      emptyText={VocabWhitelistForm.whitelist_empty[lan] || 'No users listed'}
      authorizedHeader={VocabWhitelistForm.authorized_users[lan] || 'Authorized Users'}
      initialUsers={whiteList || []}
      {...(initialUsername ? { initialSearchQuery: initialUsername } : {})}
      onSearchUser={(query: string) => WhitelistService.searchUserWhitelist(query)}
      onSave={handleSave}
      {...(onSaveSuccess ? { onSaveSuccess } : {})}
    />
  );
};

export default WhitelistWidget;